import { Component, input, output } from '@angular/core'

@Component({
  selector: 'app-popover',
  imports: [],
  templateUrl: './popover.component.html',
  styleUrl: './popover.component.scss',
})
export class PopoverComponent {
  isOpen = input<boolean>()
  popoverClosed = output()

  emitClose() {
    this.popoverClosed.emit()
  }
}
